import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'saving': false,
  'loadingHistory': false,
  'activeChart': false,
  'selectedValue': '',
  'totalLimit': 0,
  'totalValue': 0,
  'yearLimits': [],
  'yearValues': [],
  'historicLimits': [],
};

const getLastValue = (values) => {
  return values.length ? values[values.length - 1] : 0;
};

const addLimitToHistoricList = (historicLimits) => {
  const date = new Date();
  
  if (!historicLimits.find((limit) => limit.year === date.getFullYear())) {
    return [{'year': date.getFullYear(), 'annualAmount': ''}, ...historicLimits];
  }

  return [{'year': date.getFullYear() + 1, 'annualAmount': ''}, ...historicLimits];
};

export const providerOrdersControl = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_PROVIDER_ORDERS_LIMITS_SELECTED_YEAR]: (state, action) => ({
      ...state,
      'activeChart': false,
    }),
    [ActionTypes.ADD_NEW_PROVIDER_ORDER_LIMIT]: (state, action) => ({
      ...state,
      'historicLimits': addLimitToHistoricList(state.historicLimits),
    }),
    [ActionTypes.GET_PROVIDER_ORDERS_LIMIT_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
      'activeChart': true,
    }),
    [ActionTypes.GET_PROVIDER_ORDERS_LIMIT_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'selectedYear': action.payload,
      'totalLimit': getLastValue(action.response.idealData),
      'totalValue': getLastValue(action.response.realAmount),
      'yearLimits': action.response.idealData,
      'yearValues': action.response.realAmount,
    }),
    [ActionTypes.GET_PROVIDER_ORDERS_LIMIT_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'activeChart': false,
      'selectedYear': '',
      'totalLimit': 0,
      'totalValue': 0,
      'yearLimits': [],
      'yearValues': [],
    }),
    [ActionTypes.SAVE_PROVIDER_ORDERS_LIMIT_REQUEST]: (state, action) => ({
      ...state,
      'saving': true,
    }),
    [ActionTypes.SAVE_PROVIDER_ORDERS_LIMIT_SUCCESS]: (state, action) => ({
      ...state,
      'saving': false,
    }),
    [ActionTypes.SAVE_PROVIDER_ORDERS_LIMIT_FAILED]: (state, action) => ({
      ...state,
      'saving': false,
    }),
    [ActionTypes.GET_PROVIDER_ORDERS_HISTORIC_LIMITS_REQUEST]: (state, actions) => ({
      ...state,
      'loadingHistory': true,
    }),
    [ActionTypes.GET_PROVIDER_ORDERS_HISTORIC_LIMITS_SUCCESS]: (state, actions) => ({
      ...state,
      'loadingHistory': false,
      'historicLimits': action.response.data,
    }),
    [ActionTypes.GET_PROVIDER_ORDERS_HISTORIC_LIMITS_FAILED]: (state, actions) => ({
      ...state,
      'loadingHistory': false,
      'historicLimits': [],
    }),
  })(state, action);
};
